import axios from 'axios';
import api from '@/api';

/* global  X2JS*/
const x2js = new X2JS();

export default {
	//获取全局设置
	async getSetting(works_id) {
		const settings = {
			background_media_id: '',
			explain_media_id: '',
			switch_planet: true,
			switch_scene: true,
			switch_audio_background: false,
			switch_audio_explain: false,
		};
		try {
			let res = await api.works.detail({works_id});
			let info = res.data.info ? res.data.info : {};
			
			for (let key in info) {
				if (info[key] != undefined) {
					settings[key] = info[key];
				}
			}
			return settings;
		} catch (e) {
			console.error(e);
		}
	},
	
	//读取XML
	getXml(settings) {
		return new Promise((resolve) => {
			let request = axios.create({});
			request({url: '/krpano/vr-preview-xml/index.xml', method: 'get'}).then((res) => {
				let xmlDoc = res.request.responseXML;
				let jsonXml = x2js.xml2json(xmlDoc);
				jsonXml.krpano.settings._is_planet = settings.switch_planet;
				jsonXml.krpano.settings._is_scene = settings.switch_scene;
				jsonXml.krpano._debugmode = process.env.NODE_ENV == 'development';
				jsonXml.krpano._showerrors = process.env.NODE_ENV == 'development';
				jsonXml.krpano._logkey = process.env.NODE_ENV == 'development';
				resolve(jsonXml);
			});
		});
	},
	
	getSceneXml(sceneList, query) {
		//this.jsonXml.krpano.scene = [];
		return sceneList.map((item) => {
			let scene = {
				_name: item.id,
				_onstart: '',
				_havevrimage: 'true',
				_heading: '0.0',
				_thumburl: '',
				_lat: '31.11608261',
				_lng: '120.84626600',
				view: {
					_hlookatmin: item.info.hlookat_range ? item.info.hlookat_range[0] : -180,
					_hlookat: item.info.hlookat_range ? item.info.hlookat_range[1] : 0,
					_hlookatmax: item.info.hlookat_range ? item.info.hlookat_range[2] : 180,
					_vlookatmin: item.info.vlookat_range ? item.info.vlookat_range[0] : -90,
					_vlookat: item.info.vlookat_range ? item.info.vlookat_range[1] : (process.env.VUE_APP_WEB == 2 ? 90 : 0),
					_vlookatmax: item.info.vlookat_range ? item.info.vlookat_range[2] : 90,
					_fovtype: 'MFOV',
					_fovmin: item.info.fov_range ? item.info.fov_range[0] : 30,
					_fov: item.info.fov_range ? item.info.fov_range[1] : 95,
					_fovmax: item.info.fov_range ? item.info.fov_range[2] : 140,
					_limitview: 'fullrage',
					_stereographic: true,
				},
				preview: {
					_url: item.preview,
				},
				image: {
					cube: {
						_url: item.path + '/%s/l%l/%v/l%l_%s_%v_%h.jpg',
						_multires: item.resolution ? item.resolution : '512,640,1280',
					},
				},
			};
			if (item.id == query.material_id && query.ath && query.atv) {
				scene.view._hlookat = query.ath;
				scene.view._vlookat = query.atv;
			}
			scene.hotspot = this.getHotSpotXml(item);
			scene.hotspot = scene.hotspot.concat(this.getHotSpotTitleXml(item));
			return scene;
		});
	},
	
	//构建热点
	getHotSpotXml(scene) {
		return scene.spot_list.map((item) => {
			let width = item.width || 70;
			let height = item.height || 70;
			let dpr = window.devicePixelRatio || 1;
			if (item.image_type == 4) {
				if (item.image_ext_preview === 'https://vybbasevr.vyb.cn/12d.png') {
					width = height = 30;
				}
				return {
					_name: item.name,
					_url: item.image_ext_preview,
					_visible: false,
					_ath: item.ath,
					_atv: item.atv,
					_width: width,
					_height: height,
					_onloaded: 'do_crop_animation(128,128,60);',
					_onclick: `js(krpjs.hsHandle(${item.material_id},${item.id}))`,
				};
			} else {
				return {
					_name: item.name,
					_type: item.type || 'image',
					_url: `${item.thumb_preview}?imageView2/1/w/${parseInt(width * dpr)}/h/${parseInt(height * dpr)}`,
					_keep: !!item.keep,
					_visible: false,
					_style: item.style || '',
					_ath: item.ath || '0',
					_atv: item.atv || '0',
					_zoom: item.is_zoom == 1,
					_title: item.title,
					_distorted: item.is_distorted == 1,
					_width: width,
					_height: height,
					_parent: item.parent || '',
					_html: item.html || '',
					_onclick: `js(krpjs.hsHandle(${scene.id},${item.id}))`,
				};
			}
		});
	},
	
	//构建热点label-标题
	getHotSpotTitleXml(scene) {
		return scene.spot_list
		.filter((item) => item.is_show_title == 1)
		.map((item) => {
			let width = item.width || 70;
			if (item.image_type == 4 && item.image_ext_preview === 'https://vybbasevr.vyb.cn/12d.png') {
				width = 30;
			}
			return {
				_name: `${item.name}_title`,
				_type: 'text',
				_html: item.title,
				_visible: false,
				_is_hide: item.is_show_title == 2,
				_ath: item.ath,
				_atv: item.atv,
				_edge: 'left',
				_ox: width / 2,
				_style: 'hotspot_label_style',
				_onclick: `js(krpjs.hsHandle(${scene.id},${item.id}))`,
			};
		});
	},
	
	//初始化krpano
	getKrp(mid, query, target = 'pano') {
		return new Promise((resolve) => {
			let id = target + 'krpanoSWFObject'
			let vars = {};
			vars.startscene = mid.toString();
			query.ath && (vars.initath = query.ath);
			query.atv && (vars.initatv = query.atv);
			vars.syncside = target === 'pano' ? 'left' : 'right';
			vars.syncviewer = target === 'pano' ? 'panoRightkrpanoSWFObject' : 'panokrpanoSWFObject';
			/* global embedpano */
			embedpano({
				id,
				xml: null,
				target,
				vars,
				html5: 'only+webgl+preserveDrawingBuffer',
				mobilescale: 1.0,
				passQueryParameters: true,
				consolelog: true,
				onready: () => {
					resolve(document.getElementById(id));
				},
			});
		});
	},
	
	//应用xml
	loadPanoXml(jsonXml, krp, flags = null, loaddone = null) {
		let xml = x2js.json2xml_str(jsonXml);
		krp.call(`loadxml(${xml},null,${flags},null,${loaddone})`);
	},
};

